import { Link, useNavigate } from "react-router-dom";
import { FeatherIcons, LI, UL } from "../../../../AbstractElements";
import { profilesMessage } from "../../../../Data/LayoutData/HeaderData";
import { authApi } from "../../../../Api";

const ProfileBox = () => {
  const navigate = useNavigate()
  const handleClick = (name:string)=>{
    if(name === "Log Out"){
      authApi.clearAuthData()
      navigate(`${process.env.PUBLIC_URL}/login`)
    }
  }
  return (
    <UL className="profile-dropdown onhover-show-div simple-list">
      {profilesMessage.map((data,index) => (
        <LI key={index}>
          <Link to={data.link} onClick={()=>handleClick(data.name)}>
            <FeatherIcons iconName={data.icon} />
            <span>{data.name} </span>
          </Link>
        </LI>
      ))}
    </UL>
  );
};

export default ProfileBox;
